import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.scss'

const IconRow: React.FC<IconRowProps> = ({
  text,
  className,
  icon,
}): JSX.Element => (
  <div className={classNames(style.location, className)}>
    {icon && <Icon type={icon} size="small" className={style.pinIcon} />}
    {text}
  </div>
)

interface IconRowProps {
  text?: string
  icon?: string
  className?: string
}

IconRow.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
}

export default IconRow
